<template>
  <div
    class="input-container password-indicator"
    :class="`password-indicator--${theme}`"
    data-cy="settings-text-passwordstrength"
    v-show="show"
  >
    <ul>
      <li>
        <i class="mdi" :class="getIcon(checkLength)"></i>
        8 {{ $tc('plural.character', 8) }}
      </li>
      <li>
        <i class="mdi" :class="getIcon(containsUppercase)"></i>
        1 {{ $tc('plural.uppercaseLetter', 1) }}
      </li>
      <li>
        <i class="mdi" :class="getIcon(containsNumber)"></i>
        1 {{ $tc('plural.digit', 1) }}
      </li>
      <li class="first-column mr10">
        <i class="mdi" :class="getIcon(containsLowercase)"></i>
        1 {{ $tc('plural.lowercaseLetter', 1) }}
      </li>
      <li>
        <i class="mdi" :class="getIcon(containsCharacter)"></i>
        1 {{ $tc('plural.specialCharacter', 1) }}
        <s-tooltip width="200" :theme="theme == 'light' ? 'dark' : 'light'"
          >! ? # % & @ $ ( ) = + - / _ ' " * :</s-tooltip
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      required: true,
      default: ''
    },
    show: {
      type: Boolean
    },
    theme: {
      type: String
    }
  },
  data() {
    return {
      OK_ICON: 'mdi-checkbox-marked-circle green-text',
      NOK_ICON: 'mdi-circle grey-text',
      MIN_PASSWORD_LEN: 8
    };
  },
  mounted() {},
  watch: {},
  computed: {
    checkLength() {
      if (this.value === undefined || this.value === null) {
        return false;
      }

      return this.value.length >= this.MIN_PASSWORD_LEN;
    },
    containsUppercase() {
      if (this.value === null) {
        return false;
      }

      return /[A-Z]/.test(this.value);
    },
    containsLowercase() {
      if (this.value === null) {
        return false;
      }

      return /[a-z]/.test(this.value);
    },
    containsNumber() {
      return /\d/.test(this.value);
    },
    containsCharacter() {
      return /[^a-zA-Z\d\s:]/.test(this.value);
    }
  },
  methods: {
    getIcon(result) {
      return result ? this.OK_ICON : this.NOK_ICON;
    }
  }
};
</script>
<style lang="scss" scoped>
.password-indicator {
  font-size: 12px;
  &--dark {
    color: white;
  }
}
.mdi {
  display: inline;
  font-size: 1.2em;
}
.first-column {
  margin-right: 10px;
  width: 160px;
}
.grey-text {
  color: #ccc !important;
}
li {
  text-transform: lowercase;
}
</style>
